export default __webpack_public_path__ + "static/media/color-02.37ca4863.svg";